import { useTranslation } from "react-i18next";
import { Box, Icon } from "../../../common/components";
import { Typography } from "@mui/material";
import { palette } from "../../../styles/theme";
import { useMemo } from "react";
import { AddressType, OrderDetail } from "../../../types";

interface Props {
  preorderDetail: OrderDetail | null;
}

const AddressIdenticalIndicator = ({ preorderDetail }: Props) => {
  const { t } = useTranslation();

  const isShippingAndBillingAddressSame = useMemo(() => {
    if (preorderDetail?.billingAddress.id === "default") {
      return true;
    }

    let isSame = true;

    if (
      Object.keys(preorderDetail?.shippingAddress?.address || {}).some(
        (key) =>
          preorderDetail?.shippingAddress?.address[
            key as keyof AddressType["address"]
          ] !==
          preorderDetail?.billingAddress?.address[
            key as keyof AddressType["address"]
          ]
      ) ||
      preorderDetail?.shippingAddress?.firstName !==
        preorderDetail?.billingAddress?.firstName ||
      preorderDetail?.shippingAddress?.lastName !==
        preorderDetail?.billingAddress?.lastName ||
      preorderDetail?.shippingAddress?.organization !==
        preorderDetail?.billingAddress?.organization ||
      preorderDetail?.shippingAddress?.phone !==
        preorderDetail?.billingAddress?.phone ||
      preorderDetail?.shippingAddress?.email !==
        preorderDetail?.billingAddress?.email
    ) {
      isSame = false;
    }

    return isSame;
  }, [preorderDetail]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <Icon
        icon={isShippingAndBillingAddressSame ? "check_circle" : "info"}
        color={
          isShippingAndBillingAddressSame
            ? palette.misc.successText
            : palette.misc.warningText
        }
      />
      <Typography
        variant="textRegular"
        color={
          isShippingAndBillingAddressSame
            ? palette.misc.successText
            : palette.misc.warningText
        }
      >
        {isShippingAndBillingAddressSame
          ? t("order.addresses_identical")
          : t("order.address_do_not_match")}
      </Typography>
    </Box>
  );
};

export default AddressIdenticalIndicator;
